export default "__VITE_ASSET__wGBoeZ3z__"